import { render, staticRenderFns } from "./activeListDialog.vue?vue&type=template&id=20caa020"
import script from "./activeListDialog.vue?vue&type=script&lang=js"
export * from "./activeListDialog.vue?vue&type=script&lang=js"
import style0 from "./activeListDialog.vue?vue&type=style&index=0&id=20caa020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports